export default "__VITE_ASSET__YsRgbUv$__"